export const MINUTES_TRESHOLD_FOR_STALE_DATA = 5;
export const REFRESH_INTERVAL_SECONDS = MINUTES_TRESHOLD_FOR_STALE_DATA * 60;
